import { TemplatePortal } from '@angular/cdk/portal';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { GlobalService } from 'src/app/_services/global.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { CallStage } from 'src/app/enums/CallStage';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';

@Component({
  selector: 'app-report-industries',
  templateUrl: './report-industries.component.html',
  styleUrls: ['./report-industries.component.scss']
})
export class ReportIndustriesComponent implements OnInit {

  constructor(
    private personSerarchService: PersonSearchService, private localstorageservice: LocalStorageService, private router: Router,
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private aggService: AggregationService,
    private filterDataHandlerService: FilterDataHandlerService,
    private hashService: HashService
  , private talentInsightsService: TalentInsightsService) { }

  industries: any;
  industriesData: any = [];
  displayedColumns: string[] = ['key', 'doc_count', 'graph'];
  @ViewChild('industriesTbSort') industriesTbSort: MatSort;

  totalResultCount: number = 0;
  aggregatescount: number = 50;
  start: number = 0;
  end: number = 10;
  currentPage: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  talentfilterdata: any = {};
  apiCalled: boolean = false;
  subscriptions: Array<Subscription> = [];
  insightsExportSubscription: Subscription = null;
  /**Sorted data of industries based on pageCount */
  industriesSortData: any;
  industrydataai: any;
  get isLocationEurope() {
    return this.localstorageservice.getItem('talentRegion') == 'europe';
  }

  ngOnInit(): void {
    // const indstrysubscription = this.personSerarchService.gettalentinsights.subscribe((response) => this.setUpdatedData(response));
    // this.subscriptions.push(indstrysubscription);

    this.setUpdatedData(null);
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.setUpdatedData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string } }) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) { 
      this.talentfilterdata = talentFilterData 
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
    this.getIndustry();
    this.personSerarchService.setTalentinsightsFilterAI(this.filterDataHandlerService.fetchFilterData)

  }

  getIndustry(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_industry';
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSerarchService.getTotalAggs(aggReq).subscribe((response) => {
      this.apiCalled = true;
      this.totalResultCount = response.data.totalresultscount;
      const tempData = response.data.aggregations.current_industry;
      this.industriesSortData = tempData;
      this.totalCount = tempData.length;
      this.industriesData = tempData.slice(this.start, this.end);
      this.industries = new MatTableDataSource(this.industriesData);
      this.industries.sort = this.industriesTbSort;
      this.manualSort();
      this.getindustriesdataai(this.industriesSortData)
    });
  }

  getIndustryPercentage(value){    
    return ( (value/this.totalResultCount) * 100).toFixed(2);
  }

  setPage(index: number){
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if(this.aggregatescount / this.pageSize <= index){
      this.aggregatescount = this.aggregatescount + this.pageSize;
      this.getIndustry();
    }
    else{
      this.manualSort();
    }
  }

  manualSort(){
    this.reSortArr(this.industriesTbSort);
  }

  reSortArr(sort){
    const tempData = this.industriesSortData;
    
    if(!sort || !sort.active || sort.direction === ''){
      this.industriesData = tempData.slice(this.start, this.end);
      this.industries = new MatTableDataSource(this.industriesData);
      this.industries.sort = this.industriesTbSort;
      return;
    }

    this.industriesSortData = tempData.sort((a,b)=>{
      const isAsc = sort.direction === 'asc';
      switch(sort.active){
        case 'doc_count' : return this.compare(a.doc_count,b.doc_count, isAsc);
        case 'graph' :  return this.compare(a.doc_count,b.doc_count, isAsc);
        default: return 0;
      }
    });
    this.industriesData = this.industriesSortData.slice(this.start, this.end);
    this.industries = new MatTableDataSource(this.industriesData);
    this.industries.sort = this.industriesTbSort;
  }

  compare(a:number, b:number, isAsc:boolean){
    return(a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getIndustryIcon(industryName){
    let iconName = GlobalService.getIndustryIcon(industryName)
    return `fa-solid fa-${iconName}`
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

   /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
   handelRedirection(type: string, key: string) {
    if(this.isLocationEurope) return;

    const additionalFilters = {};
    switch(type) {
      case 'industry': additionalFilters['mandatoryindustries'] = [key]; break;
    }

    this.talentfilterdata['additionalFilters'] = additionalFilters;
    // this.localstorageservice.setItem('talentfilters', JSON.stringify(this.talentfilterdata));
    // this.personSerarchService.setTalentinsights(this.talentfilterdata);
    // this.router.navigate(['/person/search/listing'], { queryParams: { 'redirectSource': 'talent-insights' } })
    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCurrentRedirection(uniqueHash, this.talentfilterdata);
    const aggReq = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=talent-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${uniqueHash}&keyword=${aggReq.booleanquery!= '*' ? aggReq.booleanquery: ''}`; 
    window.open(url, "_blank");
  }

  getindustriesdataai(data) {
    let industrydata: any;
    industrydata = data.map(x=>{
      let res: any ={};
      res['Top Industries'] = x.key;
      res['Talent Count'] = x.doc_count;
      res['% of Total'] = this.getIndustryPercentage(x.doc_count)+'%';
      return res;
    
    })
    this.industrydataai = {
      industries: industrydata
    }
    if(industrydata.length == 0)
      this.industrydataai = null;
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if(requestData?.data?.currentTab !== 'industries') return;

    const payloadForInsightsExport = {
      tab: 'industries',
      totalresultcount: this.totalResultCount,
      industries: this.industriesSortData.map((ind: any) => ({ ...ind, icon: this.getIndustryIcon(ind.key) }))
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }
}
